import { Component, Input, OnInit } from "@angular/core"
import { UserService } from "../../../services/user.service"
import { CardComponent } from "../card.component"
import { routeAnimations, routeTransition } from "../../../utils/animations"

@Component({
    selector: "app-collection-card",
    templateUrl: "./collection-card.component.html",
    styleUrls: ["./collection-card.component.scss"],
    host: { "[@routeTransition]": "true", "[@routeAnimations]": "false", style: "display: block;" },
    animations: [routeTransition, routeAnimations],
    standalone: false,
})
export class CollectionCardComponent extends CardComponent implements OnInit {
    @Input() public gtmDataCardNumber: number
    @Input() posterImageDimension: string

    constructor(public userService: UserService) {
        super(userService)
    }

    public ngOnInit() {
        this.showAsCollection = true
    }
}
